import { render, staticRenderFns } from "./InviteFriendList.vue?vue&type=template&id=1233c5cc&"
import script from "./InviteFriendList.vue?vue&type=script&lang=js&"
export * from "./InviteFriendList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports